import { createQueryKeys } from "@lukemorales/query-key-factory";

import type { CoreApiClient } from "../client";
import type { GetRolesResponseBody, Session } from "../types/auth.type";

export const createAuthQueries = (api: CoreApiClient) => {
  const { client } = api;

  /**
   * `token` is only needed while signing in, before the token reaches storage and the client's auth
   * middleware can pick it up on its own.
   */
  const session = async (token?: string): Promise<Session> => {
    const { data, error, response } = await client.GET("/get-session", {
      ...(token ? { headers: { Authorization: `Bearer ${token}` } } : {}),
    });
    if (error) throw new Error(`Get session failed [status:${response.status}]`);
    return data;
  };

  const roles = async (): Promise<GetRolesResponseBody> => {
    const { data, error, response } = await client.GET("/roles");
    if (error) throw new Error(`Get roles failed [status:${response.status}]`);
    return data;
  };

  return {
    session,
    roles,
    queries: createQueryKeys("auth", {
      session: (token?: string) => ({
        queryKey: [token ?? "current"],
        queryFn: () => session(token),
      }),
      roles: { queryKey: null, queryFn: roles },
    }),
  };
};
